import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-settings-layout',
  templateUrl: './settings-layout.component.html',
  styleUrl: './settings-layout.component.scss'
})
export class SettingsLayoutComponent implements OnInit{
  userMenuItems: MenuItem[] = [];
  constructor( protected router: Router) {
  }

  ngOnInit(): void {
    this.userMenuItems = [
      {
          label: 'Users',
          icon: 'pi pi-user',
          items: [
            {
              label: 'Users List',
              icon: 'pi pi-users',
              command: () => this.router.navigateByUrl('users')
            },
              {
                  label: 'Add User',
                  icon: 'pi pi-user-plus',
                  command: () => this.router.navigateByUrl('users/add')
              },
          ]
      },
      {
          label: 'Organizations',
          icon: 'pi pi-building-columns',
          items: [
              {
                  label: 'Add Organization',
                  icon: 'pi pi-building',
              },
              {
                  label: 'Deleted Organization',
                  icon: 'pi pi-trash',
              }
          ]
      },
  ];
  }
}
